/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditInline = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m18.13 1.309 4.332 4.414L6.332 22H2v-3.994zM21 20v2H11v-2zM14.568 7.83 3.962 18.834V20h1.556L16.087 9.349zm3.562-3.692-2.173 2.25 1.539 1.54 2.19-2.205z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEditInline as EditInline };
